import { render } from "./EntityAttributeForms.vue?vue&type=template&id=7fc5e9b4&scoped=true"
import script from "./EntityAttributeForms.vue?vue&type=script&lang=js"
export * from "./EntityAttributeForms.vue?vue&type=script&lang=js"

import "./EntityAttributeForms.vue?vue&type=style&index=0&id=7fc5e9b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc5e9b4"]])

export default __exports__